<template>
  <div>


    <cc-collapse :title="$t('ct-general-settings')">

      <cc-slider-component ref="widthConfig"><</cc-slider-component>

      <div class="form-group">
        <cc-box-color ref="backgroundColor"></cc-box-color>
      </div>

      <div class="form-group">
        <cc-box-color ref="backgroundColorHover"></cc-box-color>
      </div>

      <div class="form-group">
        <cc-box-color ref="iconColor"></cc-box-color>
      </div>

      <div class="form-group">
        <input @change="save" type="checkbox" id="show-showPlaceholder" v-model="config.showPlaceholder">
        <label for="show-showPlaceholder"> Show PlaceHolder</label>
      </div>

      <div v-show="config.showPlaceholder" class="form-group">
        <label for="labelText">Label</label>
        <input id="labelText" @change="save" v-model="config.lbltext" type="text" class="form-control">
      </div>

    </cc-collapse>
  </div>

</template>

<script>

  export default {
    name: "Options",
    data () {
      return {
        config: {
          placeholder: '',
          showPlaceholder: '',
          lbltext: ''
        },
        callback: () => {}
      }
    },
    methods: {
      init(config, callback) {
        let vm = this;

        vm.config = _.clone(config);
        vm.callback = callback;

        this.$refs['backgroundColor'].setValues({defaultValue : vm.config.backgroundColor, gradient: false, labelDesc: 'bg-color', name: 'backgroundColor', callback: vm.setBackgroundColor });
        this.$refs['backgroundColorHover'].setValues({defaultValue : vm.config.backgroundColorHover, gradient: false, labelDesc: 'bg-color-hover', name: 'backgroundColorHover', callback: vm.setBackgroundColorHover });
        this.$refs['iconColor'].setValues({defaultValue : vm.config.titleStyle.color, gradient: false, labelDesc: 'bg-icon-color', name: 'iconColor', callback: vm.setIconColor });
        this.$refs['widthConfig'].setValues({defaultValue: vm.config.width, defaultValueChecked : false, min: 50, max: 800, canBeCheckbox: false, labelDesc: 'width', name: 'iconColor', callback: vm.setWidth });

      },
      setBackgroundColor(value) {
        this.config.backgroundColor = value;
        this.save();
      },
      setBackgroundColorHover(value) {
        this.config.backgroundColorHover = value;
        this.save();
      },
      setIconColor(value) {
        this.config.titleStyle.color = value;
        this.save();
      },
      setWidth(value) {
        this.config.width = `${value}px`;
        this.save();
      },
      save() {
        this.callback(this.config);
      }
    },
    beforeDestroy() {
      this.config = {};
      this.callback = () => {};
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Blog/Search/Options.vue